const TEMPLATE_ASSET_FAMILIES = {
  royal_wedding_mobile_video_v1: {
    id: "royal_wedding_mobile_video_v1",
    specId: "royal-wedding-mobile-video-v1",
    label: "Royal Wedding Mobile Video v1",
    eventType: "wedding",
    styleFamily: "royal",
    format: "mobile_video",
    basePath: "/template-assets/royal-wedding/v1",
    storagePrefix: "templates/royal-wedding/v1",
    assets: {
      hero_background: {
        role: "hero_background",
        displayName: "Hero Background",
        type: "image",
        sourceStrategy: "generate",
        path: "hero-background-placeholder.svg",
        placeholder: true,
        required: true,
        editable: true,
        reusable: true,
        description: "Primary cinematic background for the opening and invitation scenes.",
        promptReference: "royal-wedding/hero-background",
        generationPrompt:
          "Portrait 9:16 royal Indian wedding invitation background, deep maroon and antique gold, ornate palace arch, warm cinematic lighting, empty center area for typography, no text, premium mobile video design.",
        negativePrompt: "text, names, faces, people, logos, watermark, blurry details, cluttered center",
        assetTagQuery: ["wedding", "royal", "indian", "background", "maroon", "gold"],
        sceneUsage: ["scene-grand-opening", "scene-invitation-message"],
        storagePath: "templates/royal-wedding/v1/generated/hero-background",
        polotnoMapping: {
          type: "image",
          slot: "background.main",
          defaultPlacement: {
            x: 0,
            y: 0,
            width: 1080,
            height: 1920,
            opacity: 1,
          },
        },
      },
      detail_background: {
        role: "detail_background",
        displayName: "Detail Background",
        type: "image",
        sourceStrategy: "generate",
        path: "detail-background-placeholder.svg",
        placeholder: true,
        required: true,
        editable: true,
        reusable: true,
        description: "Softer secondary background for date, venue, and RSVP scenes.",
        promptReference: "royal-wedding/detail-background",
        generationPrompt:
          "Portrait 9:16 Indian wedding invitation detail background, elegant antique gold texture on muted royal palette, subtle mandala pattern, clean readable center, no text, refined luxury stationery style.",
        negativePrompt: "text, names, faces, people, logos, watermark, noisy texture, low contrast text area",
        assetTagQuery: ["wedding", "royal", "indian", "background", "detail", "gold"],
        sceneUsage: ["scene-ceremony-details", "scene-venue-address", "scene-closing-rsvp"],
        storagePath: "templates/royal-wedding/v1/generated/detail-background",
        polotnoMapping: {
          type: "image",
          slot: "background.main",
          defaultPlacement: {
            x: 0,
            y: 0,
            width: 1080,
            height: 1920,
            opacity: 1,
          },
        },
      },
      royal_arch_frame: {
        role: "royal_arch_frame",
        displayName: "Royal Arch Frame",
        type: "svg",
        sourceStrategy: "reuse_existing",
        path: "royal-arch.svg",
        required: true,
        editable: true,
        reusable: true,
        description: "Royal Indian arch frame for hero and venue scenes.",
        promptReference: "royal-wedding/royal-arch-frame",
        generationPrompt:
          "Transparent SVG-style royal Indian palace arch frame, antique gold line art, ornate Mughal and Rajasthani inspired details, symmetrical, no text, clean vector edges.",
        negativePrompt: "text, raster texture, filled background, people, faces, logos, watermark",
        assetTagQuery: ["wedding", "royal", "arch", "frame", "svg", "gold"],
        sceneUsage: ["scene-grand-opening", "scene-venue-address"],
        storagePath: "templates/royal-wedding/v1/royal-arch.svg",
        polotnoMapping: {
          type: "svg",
          slot: "ornament.frame",
          defaultPlacement: {
            x: 140,
            y: 130,
            width: 800,
            height: 1088,
            opacity: 0.4,
          },
        },
      },
      mandala_centerpiece: {
        role: "mandala_centerpiece",
        displayName: "Mandala Centerpiece",
        type: "svg",
        sourceStrategy: "reuse_existing",
        path: "mandala.svg",
        required: true,
        editable: true,
        reusable: true,
        description: "Mandala centerpiece or watermark for ceremonial emphasis.",
        promptReference: "royal-wedding/mandala-centerpiece",
        generationPrompt:
          "Transparent SVG-style Indian wedding mandala centerpiece, antique gold line art, symmetrical lotus and paisley geometry, ornate but readable, no text, clean vector.",
        negativePrompt: "text, raster background, people, faces, logos, watermark, asymmetry",
        assetTagQuery: ["wedding", "mandala", "centerpiece", "svg", "gold"],
        sceneUsage: ["scene-grand-opening", "scene-ceremony-details", "scene-closing-rsvp"],
        storagePath: "templates/royal-wedding/v1/mandala.svg",
        polotnoMapping: {
          type: "svg",
          slot: "ornament.centerpiece",
          defaultPlacement: {
            x: 250,
            y: 1088,
            width: 580,
            height: 580,
            opacity: 0.62,
          },
        },
      },
      ornamental_divider: {
        role: "ornamental_divider",
        displayName: "Ornamental Divider",
        type: "svg",
        sourceStrategy: "reuse_existing",
        path: "ornamental-divider.svg",
        required: true,
        editable: true,
        reusable: true,
        description: "Gold decorative divider for section breaks.",
        promptReference: "royal-wedding/divider-ornament",
        generationPrompt:
          "Transparent SVG-style horizontal Indian wedding ornamental divider, antique gold, elegant paisley flourishes, symmetrical, thin vector line art, no text.",
        negativePrompt: "text, background, people, faces, logos, watermark, thick heavy shapes",
        assetTagQuery: ["wedding", "divider", "ornament", "svg", "gold"],
        sceneUsage: [
          "scene-grand-opening",
          "scene-invitation-message",
          "scene-ceremony-details",
          "scene-venue-address",
          "scene-closing-rsvp",
        ],
        storagePath: "templates/royal-wedding/v1/ornamental-divider.svg",
        polotnoMapping: {
          type: "svg",
          slot: "ornament.divider",
          defaultPlacement: {
            x: 300,
            y: 420,
            width: 480,
            height: 64,
            opacity: 0.95,
          },
        },
      },
      paisley_corner: {
        role: "paisley_corner",
        displayName: "Paisley Corner",
        type: "svg",
        sourceStrategy: "reuse_existing",
        path: "paisley-corner.svg",
        required: true,
        editable: true,
        reusable: true,
        description: "Corner paisley ornament for royal framing.",
        promptReference: "royal-wedding/paisley-corner",
        generationPrompt:
          "Transparent SVG-style Indian paisley corner ornament, antique gold line art, ornate but lightweight, designed for invitation frame corners, no text.",
        negativePrompt: "text, background, people, faces, logos, watermark, full frame",
        assetTagQuery: ["wedding", "paisley", "corner", "svg", "gold"],
        sceneUsage: ["scene-grand-opening", "scene-invitation-message"],
        storagePath: "templates/royal-wedding/v1/paisley-corner.svg",
        polotnoMapping: {
          type: "svg",
          slot: "ornament.corner",
          defaultPlacement: {
            x: 62,
            y: 96,
            width: 220,
            height: 220,
            opacity: 0.75,
          },
        },
      },
      sparkle_overlay: {
        role: "sparkle_overlay",
        displayName: "Sparkle Overlay",
        type: "svg",
        sourceStrategy: "reuse_existing",
        path: "sparkle-overlay.svg",
        required: true,
        editable: true,
        reusable: true,
        description: "Sparkle overlay accent for closing and blessing scenes.",
        promptReference: "royal-wedding/sparkle-overlay",
        generationPrompt:
          "Transparent SVG-style subtle golden sparkle overlay for luxury Indian wedding invitation, scattered small stars and glints, airy, no text, no background.",
        negativePrompt: "text, heavy glitter, background fill, logos, watermark, dense clutter",
        assetTagQuery: ["wedding", "sparkle", "overlay", "svg", "gold"],
        sceneUsage: ["scene-closing-rsvp"],
        storagePath: "templates/royal-wedding/v1/sparkle-overlay.svg",
        polotnoMapping: {
          type: "svg",
          slot: "overlay.sparkle",
          defaultPlacement: {
            x: 280,
            y: 270,
            width: 520,
            height: 520,
            opacity: 0.25,
          },
        },
      },
      music_bed: {
        role: "music_bed",
        displayName: "Wedding Music Bed",
        type: "audio",
        sourceStrategy: "prompt_only",
        required: false,
        editable: true,
        reusable: true,
        description: "Optional royalty-safe instrumental background music for preview video exports.",
        promptReference: "royal-wedding/music-bed",
        generationPrompt:
          "Royal Indian wedding instrumental music bed, warm shehnai-inspired melody, soft tabla pulse, cinematic but elegant, 24 seconds, loop-friendly, no vocals.",
        negativePrompt: "vocals, copyrighted melody, harsh drums, club beat, distorted audio",
        assetTagQuery: ["wedding", "music", "instrumental", "royal", "indian"],
        sceneUsage: [
          "scene-grand-opening",
          "scene-invitation-message",
          "scene-ceremony-details",
          "scene-venue-address",
          "scene-closing-rsvp",
        ],
        storagePath: "templates/royal-wedding/v1/generated/music-bed",
        polotnoMapping: {
          type: "audio",
          slot: "audio.background",
          defaultPlacement: {
            startTime: 0,
            duration: 24000,
            volume: 0.45,
          },
        },
      },
    },
  },
};

function getAssetFamily(familyId) {
  return TEMPLATE_ASSET_FAMILIES[familyId] || null;
}

export function getTemplateAssetRefs(familyId) {
  const family = getAssetFamily(familyId);
  if (!family) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(family.assets).map(([key, asset]) => [
      key,
      {
        ...asset,
        src: asset.path ? `${family.basePath}/${asset.path}` : "",
        familyId: family.id,
        specId: family.specId,
      },
    ])
  );
}

export function getTemplateAssetPlan(familyId) {
  const family = getAssetFamily(familyId);
  if (!family) {
    return [];
  }

  return Object.entries(family.assets).map(([assetKey, asset]) => ({
    assetKey,
    familyId: family.id,
    specId: family.specId,
    role: asset.role,
    displayName: asset.displayName,
    type: asset.type,
    sourceStrategy: asset.sourceStrategy,
    required: Boolean(asset.required),
    editable: asset.editable !== false,
    reusable: asset.reusable !== false,
    src: asset.path ? `${family.basePath}/${asset.path}` : "",
    storagePath: asset.storagePath || `${family.storagePrefix}/${asset.path || assetKey}`,
    sceneUsage: asset.sceneUsage || [],
    promptReference: asset.promptReference || "",
    generationPrompt: asset.generationPrompt || "",
    negativePrompt: asset.negativePrompt || "",
    assetTagQuery: asset.assetTagQuery || [],
    polotnoMapping: asset.polotnoMapping || null,
  }));
}

export { TEMPLATE_ASSET_FAMILIES };
